define('course-componentVM',['knockout', 'component-glossary', 'component-footer-timeline'], function(ko, Glossary, FooterTimeline) {

    return function(parentVM, dataContext) {
        var self = this;

        if (!dataContext.learning || !dataContext.learning.current) {
            return;
        }

        self.glossary = new Glossary(parentVM, dataContext);
        self.footerTimeline = new FooterTimeline(parentVM, dataContext);
    }
});

